import React, { memo } from 'react'

import ComingSoon from "../../commons/ComingSoon"

const Destinations = () => {
  return (
    <>
      <ComingSoon />
    </>
  )
}

export default memo(Destinations)
